import type { AvailabilityInfo } from '../../constants/props';
import formatDateAndMonth from '../formatDateAndMonth';

enum DaysRange {
  SameDayDelivery,
  UnderFourDays,
  Tomorrow,
  OverFourDays,
  Unknown
}

function getDaysRange(daysUntilDeliveryOrPickup: number) {
  if (daysUntilDeliveryOrPickup < 1) return DaysRange.SameDayDelivery;
  if (daysUntilDeliveryOrPickup === 1) return DaysRange.Tomorrow;
  if (daysUntilDeliveryOrPickup > 1 && daysUntilDeliveryOrPickup <= 4)
    return DaysRange.UnderFourDays;
  if (daysUntilDeliveryOrPickup > 4) return DaysRange.OverFourDays;

  return DaysRange.Unknown;
}

type GetItBy = {
  activityType?: string;
  getItBy: string;
  routeId?: string;
  utcSoonestDateTimeIso: string;
};

type Options = {
  ordinalDay?: boolean;
  sentenceCase?: boolean;
  truncateDay?: boolean;
  truncateMonth?: boolean;
};

export default function calculateGetItBy(
  {
    activityType,
    asSoonAsText,
    daysToAvailability,
    routeId,
    utcSoonestDateTimeIso
  }: Partial<AvailabilityInfo>,
  options?: Options
): GetItBy {
  const {
    ordinalDay = true,
    sentenceCase = false,
    truncateDay = true,
    truncateMonth = true
  } = options ?? {};
  if (!utcSoonestDateTimeIso || daysToAvailability === undefined) {
    return {
      activityType: '',
      getItBy: '',
      routeId: '',
      utcSoonestDateTimeIso: ''
    };
  }

  const chipTextMap = {
    [DaysRange.SameDayDelivery]: sentenceCase ? 'today' : 'Today',
    [DaysRange.UnderFourDays]: asSoonAsText,
    [DaysRange.Tomorrow]: sentenceCase ? 'tomorrow' : 'Tomorrow',
    [DaysRange.OverFourDays]: formatDateAndMonth(
      utcSoonestDateTimeIso,
      truncateDay,
      truncateMonth,
      ordinalDay
    ),
    [DaysRange.Unknown]: ''
  };

  return {
    activityType,
    getItBy: chipTextMap[getDaysRange(daysToAvailability)] ?? '',
    routeId,
    utcSoonestDateTimeIso
  };
}
